import { CobaltClickableTile } from '@cae/cobalt-react/components/tile';
import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import { CobaltIconChevronRightSolid } from '@cae/cobalt-react/icons/solid/CobaltIconChevronRightSolid';
import { ContentLoader } from '@shared/components/content-loader/ContentLoader';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import * as React from 'react';

import { useUserNotificationPreferences } from '../../hooks/use-user-notification-preference/useUserNotificationPreferences';
import { REASON_CODE } from './Notifications.constants';
import styles from './Notifications.module.css';
import { NotificationsPreferencesPanel } from './preferences-panel/NotificationsPreferencesPanel';

const Notifications = React.memo((): React.ReactElement => {
  const isMobile = useMediaQuery(MediaQuery.Mobile);
  const {
    data: notificationPreferences,
    isLoading,
    isError,
  } = useUserNotificationPreferences();

  const notificationPreference = notificationPreferences?.find(
    preference => preference.definition.reasonCode === REASON_CODE
  );
  const hasSms =
    notificationPreference?.definition?.preferredChannels?.includes('sms') ??
    false;
  const [resetNotificationsSidepanelOpen, setResetNotificationsSidepanelOpen] =
    React.useState(false);

  const handleNotificationsClick = React.useCallback((): void => {
    setResetNotificationsSidepanelOpen(true);
  }, []);

  const handleCloseResetNotificationsSidepanel = React.useCallback((): void => {
    setResetNotificationsSidepanelOpen(false);
  }, []);

  if (isLoading) return <ContentLoader />;
  if (isError) return <InlineFeedback type="data-error" />;

  return (
    <div className={styles.notifications} data-heap-id="notifications">
      {!isMobile && <h2 className={'heading-02'}>Notifications</h2>}
      <div className={styles.schedule}>
        <div className={'heading-01'}>Schedule</div>
        <CobaltClickableTile
          data-heap-id="profile-notifications-schedule-changes-tile"
          onClick={handleNotificationsClick}
        >
          <div className={styles.tileContent}>
            <span className={`body-02`}>Train: Schedule changes</span>
            <span className={`${styles.secondaryText} body-01`}>
              SMS: {hasSms ? 'On' : 'Off'}
            </span>
          </div>
          <CobaltIconChevronRightSolid size="small" />
        </CobaltClickableTile>
      </div>
      <NotificationsPreferencesPanel
        isOpen={resetNotificationsSidepanelOpen}
        onClose={handleCloseResetNotificationsSidepanel}
        notificationPreferences={notificationPreference}
      />
    </div>
  );
});

Notifications.displayName = 'Notifications';
export { Notifications };
